import { useCore } from '@/composables/core'
import { readonly, ref, type DeepReadonly, type Ref } from 'vue'

const isLoadingScreen = ref<boolean>(false)

type LoadingScreenOptions = Record<string, unknown>

const show = (options: LoadingScreenOptions = {}): void => {
  const { store } = useCore()
  store.dispatch('loadingScreen/show', options)

  isLoadingScreen.value = true
}

const hide = (): void => {
  const { store } = useCore()
  store.dispatch('loadingScreen/hide')

  isLoadingScreen.value = false
}

type UseLoadingScreenResult = {
  show: (options?: LoadingScreenOptions) => void
  hide: () => void
  loadingScreenVisible: DeepReadonly<Ref<boolean>>
}

export function useLoadingScreen (): UseLoadingScreenResult {
  return {
    show,
    hide,
    loadingScreenVisible: readonly(isLoadingScreen),
  }
}
